import { LogType } from "@/graphql/types";
import { ref } from "vue";

export default function useLogSidebar() {
  const selectedLog = ref<LogType | null>(null);

  function showLogSidebar(log: LogType) {
    selectedLog.value = log;
  }

  function hideLogSidebar() {
    selectedLog.value = null;
  }

  return {
    selectedLog,
    showLogSidebar,
    hideLogSidebar,
  };
}
